import React from 'react';
import { HashRouter, Route, Switch } from "react-router-dom";
import './App.scss';
import Default from "./components/Default";
import LaunchPatient from "./components/LaunchPatient";
import PatientPortalSelector from "./components/PatientPortalSelector";
import Scopes from "./components/Scopes";

function App() {
    return (
        <div className="App fill-space--absolute">
            <HashRouter>
                <Switch>
                    <Route path="/scopes">
                        <Scopes/>
                    </Route>
                    <Route path="/launchpatient">
                        <LaunchPatient/>
                    </Route>
                    <Route path="/patient-portal-selector">
                        <PatientPortalSelector/>
                    </Route>
                    <Route path="/">
                        <Default/>
                    </Route>
                </Switch>
            </HashRouter>
        </div>
      )
    }
    
    export default App
